import Block from 'quill/blots/block';
import Text from 'quill/blots/text';
import type Quill from 'quill/core';

const SAMPLE_COUNT = 10;
const CAPITAL_LETTER_REGEX = /[A-Z]/;

const getSampleWords = (quill: Quill) => {
  const lines = quill.getLines();
  const sampleWords: string[] = [];

  for (const line of lines) {
    if (line instanceof Block) {
      const texts = line.descendants(Text);
      for (const text of texts) {
        const words = text
          .value()
          .split(/[\s.?!,:;"'()]/)
          .filter((v) => v.length > 1);
        for (const word of words) {
          if (!CAPITAL_LETTER_REGEX.test(word)) {
            sampleWords.push(word);
            if (sampleWords.length >= SAMPLE_COUNT) {
              return sampleWords;
            }
          }
        }
      }
    }
  }
  return null;
};

export default getSampleWords;
